import { render } from "./InkSignatureModal.vue?vue&type=template&id=2093d34c&scoped=true"
import script from "./InkSignatureModal.vue?vue&type=script&lang=js"
export * from "./InkSignatureModal.vue?vue&type=script&lang=js"

import "./InkSignatureModal.vue?vue&type=style&index=0&id=2093d34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2093d34c"]])

export default __exports__